
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import CreativeDesignSection from './components/CreativeDesignSection';
import VacationRentalSection from './components/VacationRentalSection';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  useEffect(() => {
    // Schema.org JSON-LD für LocalBusiness
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Jo Allround Service",
      "description": "Professionelle Handwerksleistungen - Trockenbau, Gartenarbeiten, Fliesenarbeiten, Wandgestaltung und mehr",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://jo-allround.de'}`,
      "telephone": "0175 / 7 44 30 33",
      "email": "info.joallround@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Rheinsberg",
        "addressRegion": "Brandenburg",
        "addressCountry": "DE"
      },
      "owner": {
        "@type": "Person",
        "name": "Joachim Karl Born"
      },
      "serviceArea": {
        "@type": "Place",
        "name": "Rheinsberg, OPR"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Handwerksleistungen",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Trockenbau",
              "description": "Professionelle Trockenbauarbeiten für Wände, Decken und Raumteilung"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Gartenarbeiten",
              "description": "Komplette Gartenpflege und Landschaftsgestaltung"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Fliesenarbeiten",
              "description": "Fachgerechte Verlegung von Fliesen in Bad, Küche und Wohnbereich"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Wandgestaltung",
              "description": "Kreative Wandgestaltung und professionelle Malerarbeiten"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Fenster & Türen",
              "description": "Montage und Reparatur von Fenstern und Türen"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Kleinreparaturen",
              "description": "Schnelle Hilfe bei allen kleinen Reparaturen im Haushalt"
            }
          }
        ]
      }
    });
    
    // Entferne vorhandenes Schema falls vorhanden
    const existingSchema = document.querySelector('script[type="application/ld+json"]');
    if (existingSchema) {
      existingSchema.remove();
    }
    
    document.head.appendChild(schemaScript);
    
    return () => {
      const script = document.querySelector('script[type="application/ld+json"]');
      if (script) {
        script.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20">
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <div id="jo-kreativ">
          <CreativeDesignSection />
        </div>
        <div id="verein-ferienhaus">
          <VacationRentalSection />
        </div>
        <ContactSection />
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
